import useAuthorized from './use-authorized';
import { Resource } from '../common/model/type/resource.enum';
import { VideoPermissions } from '../common/model/type/video-permissions';

export function useVideoPermissions(): VideoPermissions {
  const {
    supervise,
    read,
    create,
    update,
    delete: remove,
  } = useAuthorized(Resource.Video);

  return {
    canRead: !!(read || supervise),
    canCreate: !!(create || supervise),
    canUpdate: !!(update || supervise),
    canDelete: !!(remove || supervise),
  };
}
